import AppConstants from "./AppConstants";
import { FORM_FIELD_ELEMENT_TYPES } from "./FormFieldConstants.mjs";

const {
  ELEMENT_TYPE_TEXT,
  ELEMENT_TYPE_SIMPLE,
  ELEMENT_TYPE_LINE,
  ELEMENT_TYPE_ICON,
  ELEMENT_TYPE_IFRAME,
  ELEMENT_TYPE_VIDEO,
  ELEMENT_TYPE_LOTTIE,
  ELEMENT_TYPE_GALLERY,
  ELEMENT_TYPE_SOCIAL_GRID,
  ELEMENT_TYPE_GRAPHIC,
  ELEMENT_TYPE_BUTTON,
  PANEL_SECTION_ELEMENT_TEXT,
  PANEL_SECTION_ELEMENT_SIMPLE,
  PANEL_SECTION_ELEMENT_LINE,
  PANEL_SECTION_ELEMENT_ICON,
  PANEL_SECTION_ELEMENT_IFRAME,
  PANEL_SECTION_ELEMENT_VIDEO,
  PANEL_SECTION_ELEMENT_LOTTIE,
  PANEL_SECTION_ELEMENT_GALLERY_IMAGES,
  PANEL_SECTION_ELEMENT_SOCIAL_GRID,
  PANEL_SECTION_ELEMENT_GRAPHIC,
  PANEL_SECTION_ELEMENT_BUTTON,
  PANEL_SECTION_ELEMENT_FORM_FIELD,
} = AppConstants;

const ElementTypeMaps = {
  [ELEMENT_TYPE_TEXT]: PANEL_SECTION_ELEMENT_TEXT,
  [ELEMENT_TYPE_SIMPLE]: PANEL_SECTION_ELEMENT_SIMPLE,
  [ELEMENT_TYPE_LINE]: PANEL_SECTION_ELEMENT_LINE,
  [ELEMENT_TYPE_ICON]: PANEL_SECTION_ELEMENT_ICON,
  [ELEMENT_TYPE_IFRAME]: PANEL_SECTION_ELEMENT_IFRAME,
  [ELEMENT_TYPE_VIDEO]: PANEL_SECTION_ELEMENT_VIDEO,
  [ELEMENT_TYPE_LOTTIE]: PANEL_SECTION_ELEMENT_LOTTIE,
  [ELEMENT_TYPE_GALLERY]: PANEL_SECTION_ELEMENT_GALLERY_IMAGES,
  [ELEMENT_TYPE_SOCIAL_GRID]: PANEL_SECTION_ELEMENT_SOCIAL_GRID,
  [ELEMENT_TYPE_GRAPHIC]: PANEL_SECTION_ELEMENT_GRAPHIC,
  [ELEMENT_TYPE_BUTTON]: PANEL_SECTION_ELEMENT_BUTTON,
  ...Object.fromEntries(
    FORM_FIELD_ELEMENT_TYPES.map((type) => [type, PANEL_SECTION_ELEMENT_FORM_FIELD]),
  ),
};

export default ElementTypeMaps;
